const testimonials = {
  hero: {
    title: "Lo Que Dicen Nuestros Clientes",
    subtitle: "Reseñas reales de clientes que confían en nosotros con sus hogares.",
    stats: [
      { value: "100+", label: "Clientes Satisfechos" },
      { value: "5.0 ★", label: "Calificación Promedio" },
      { value: "98%", label: "Recomendarían" },
    ],
  },
  filters: {
    all: "Todos",
    cleaning: "Limpieza",
    handyman: "Reparaciones",
    fiveStar: "5 Estrellas",
  },
  items: [
    {
      id: 1,
      name: "Maria Rodriguez",
      location: "Royal Palm Beach, FL",
      service: "Limpieza Residencial",
      category: "cleaning",
      rating: 5,
      title: "¡Servicio absolutamente increíble!",
      text: "¡Adry & Mich transformó mi hogar! Cada rincón estaba impecable. Son profesionales, puntuales y realmente se preocupan por la calidad de su trabajo. Llevo 6 meses usando su servicio y no podría estar más feliz.",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latina%20woman%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av1&orientation=squarish",
    },
    {
      id: 2,
      name: "James Thompson",
      location: "Wellington, FL",
      service: "Reparación de Drywall",
      category: "handyman",
      rating: 5,
      title: "¡Repararon mis paredes perfectamente!",
      text: "Tenía varios hoyos en el drywall por mover muebles. Vinieron, repararon todo y ni se nota que hubo daño. Rápido, limpio y muy asequible. ¡Muy recomendado!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av2&orientation=squarish",
    },
    {
      id: 3,
      name: "Sarah Mitchell",
      location: "Royal Palm Beach, FL",
      service: "Limpieza Airbnb",
      category: "cleaning",
      rating: 5,
      title: "¡A mis huéspedes de Airbnb les encanta!",
      text: "Desde que empecé a usar Adry & Mich para mis cambios de Airbnb, mis calificaciones subieron a 5 estrellas consistentemente. Son confiables, minuciosos y siempre listos con poco aviso. ¡La mejor inversión que he hecho!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20woman%20portrait%20professional%20headshot%20warm%20natural%20light%20blonde&width=80&height=80&seq=av3&orientation=squarish",
    },
    {
      id: 4,
      name: "Carlos Mendez",
      location: "West Palm Beach, FL",
      service: "Pintura Interior",
      category: "handyman",
      rating: 5,
      title: "¡Excelente trabajo de pintura!",
      text: "Pintaron toda mi sala y pasillo. El acabado es perfecto, líneas limpias, sin goteos. Protegieron todos mis muebles y limpiaron después. ¡Equipo muy profesional!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latino%20man%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av4&orientation=squarish",
    },
    {
      id: 5,
      name: "Linda Foster",
      location: "Palm Beach Gardens, FL",
      service: "Limpieza Profunda",
      category: "cleaning",
      rating: 5,
      title: "¡Mi casa nunca había estado tan limpia!",
      text: "Pedí una limpieza profunda antes de una reunión familiar y superaron todas mis expectativas. Limpiaron áreas en las que ni pensé. ¡La cocina y los baños estaban absolutamente brillantes!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20older%20woman%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av5&orientation=squarish",
    },
    {
      id: 6,
      name: "Robert Kim",
      location: "Lake Worth, FL",
      service: "Instalación de TV",
      category: "handyman",
      rating: 5,
      title: "¡Instalación limpia y profesional!",
      text: "Instalaron mi TV de 75 pulgadas y manejaron todos los cables perfectamente. La pared luce limpia y el TV está perfectamente nivelado. Terminaron en menos de una hora. ¡Muy impresionado!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20asian%20man%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av6&orientation=squarish",
    },
    {
      id: 7,
      name: "Patricia Gonzalez",
      location: "Royal Palm Beach, FL",
      service: "Limpieza de Mudanza",
      category: "cleaning",
      rating: 5,
      title: "¡Recuperé mi depósito completo!",
      text: "Los contraté para una limpieza de mudanza y recuperé mi depósito de seguridad completo. El propietario quedó asombrado de lo limpio que estaba el apartamento. Vale cada centavo. ¡Gracias Adry & Mich!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latina%20woman%20portrait%20professional%20headshot%20warm%20natural%20light%20dark%20hair&width=80&height=80&seq=av7&orientation=squarish",
    },
    {
      id: 8,
      name: "David Williams",
      location: "Wellington, FL",
      service: "Lavado a Presión",
      category: "handyman",
      rating: 5,
      title: "¡La entrada parece nueva!",
      text: "Mi entrada y patio estaban cubiertos de años de suciedad. Después de su servicio de lavado a presión, ¡parece concreto nuevo! Servicio rápido y precio muy razonable. Definitivamente usaré de nuevo.",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20portrait%20professional%20headshot%20warm%20natural%20light%20brown%20hair&width=80&height=80&seq=av8&orientation=squarish",
    },
  ],
};

export default testimonials;
